import { render, staticRenderFns } from "./improveSafety.popup-chunk.vue?vue&type=template&id=5b850972&scoped=true"
import script from "./improveSafety.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./improveSafety.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./improveSafety.popup-chunk.vue?vue&type=style&index=0&id=5b850972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b850972",
  null
  
)

export default component.exports